import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const voidVolume = {
    jpath: ['spectra', 'voidVolume'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default voidVolume;
//# sourceMappingURL=voidVolume.js.map